var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1868 26.2453L10.6533 17.592C2.76022 28.5201 2.76022 43.4798 10.6533 54.4085L19.1868 45.7547C15.6929 39.756 15.6929 32.2439 19.1868 26.2459V26.2453ZM45.1189 52.5428C39.2035 56.0859 31.7958 56.0859 25.8811 52.5428L17.3481 61.1966C28.1243 69.2016 42.8761 69.2016 53.6529 61.1966L45.1189 52.5428ZM25.8811 19.4567C31.7965 15.9142 39.2042 15.9142 45.1189 19.4567L53.6524 10.8034C42.8756 2.79843 28.1227 2.79843 17.3476 10.8034L25.8811 19.4567ZM51.8132 45.7541L60.3467 54.408C68.2398 43.4793 68.2398 28.5185 60.3467 17.5915L51.8132 26.2448C55.3071 32.2435 55.3071 39.7556 51.8132 45.7536V45.7541ZM10.398 61.4555C-3.466 47.3968 -3.466 24.603 10.398 10.544C24.262 -3.51467 46.7383 -3.51467 60.602 10.544C74.466 24.6034 74.466 47.3982 60.602 61.4555C46.738 75.5148 24.2617 75.5148 10.398 61.4555ZM25.4592 46.182C31.0048 51.8058 39.996 51.8058 45.5422 46.182C51.0871 40.5583 51.0871 31.4404 45.5422 25.8178C39.9965 20.194 31.0053 20.194 25.4592 25.8178C19.9142 31.4409 19.9142 40.5588 25.4592 46.182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterWheel);
export default __webpack_public_path__ + "static/media/helpCenterWheel.6c4eca5b95d8e92b00b597dabce5f993.svg";
export { ForwardRef as ReactComponent };